// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/seller/index",
    element: lazy(() => import("../pages/ManageSeller")),
  },
  {
    path: "/seller/organization",
    element: lazy(() => import("../pages/ManageSeller/organizationDetails")),
  },
  {
    path: "/seller/bank_details",
    element: lazy(() => import("../pages/ManageSeller/bankDetails")),
  },
  {
    path: "/seller/statutory_details",
    element: lazy(() => import("../pages/ManageSeller/statutoryDetails")),
  },
  {
    path: "/seller/market_details",
    element: lazy(() => import("../pages/ManageSeller/marketDetails")),
  },
  {
    path: "/seller/gst_details",
    element: lazy(() => import("../pages/ManageSeller/gstDetails")),
  },
  {
    path: "/seller/warehouse_details",
    element: lazy(() => import("../pages/ManageSeller/warehouseDetails")),
  },
  {
    path: "/seller/shipping_details",
    element: lazy(() => import("../pages/ManageSeller/shippingDetails")),
  },
  {
    path: "/seller/step",
    element: lazy(() => import("../pages/ManageSeller/step")),
  },
  {
    path: "/seller/roles_responsbilities",
    element: lazy(() => import("../pages/ManageSeller/roles")),
  },
];

export default routes;
